import './functions';
import './variables';
import './virtuals';
import './statics';
import { wrapperBuilder } from './build';

export const TestingWrapper = wrapperBuilder.build();
